import React from "react";
import { Reveal } from "./Reveal";

const STEPS = [
  { n: "01", title: "Discovery & Landscape Audit", desc: "A rigorous audit of the market, competitor vulnerabilities and the client's current assets — isolating positioning leaks and messaging friction before a single pixel is drawn." },
  { n: "02", title: "Strategy", desc: "Positioning, messaging and a clear creative direction that gives every decision a purpose." },
  { n: "03", title: "Brand Identity", desc: "Logo, colour, type and visual system — a distinctive identity built to last and to scale." },
  { n: "04", title: "Design Execution", desc: "High-stakes commercial assets crafted to premium standards — Investor Pitch Decks, Conversion-Focused Landing Pages and Multi-Channel Social Frameworks." },
  { n: "05", title: "Feedback & Refinement", desc: "Collaborative rounds to sharpen every detail until it's exactly right." },
  { n: "06", title: "Launch & Ongoing Support", desc: "AI-assisted production workflows deliver rapid visual asset scale without sacrificing premium creative integrity — and a long-term partnership to keep momentum after launch." },
];

export const Process = () => {
  return (
    <section id="process" className="py-24 md:py-32 lg:py-40 bg-charcoal text-cream" data-testid="process-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-16 md:mb-24">
          <Reveal>
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-gold" />
              <span className="text-xs tracking-[0.25em] uppercase font-semibold text-gold">Process</span>
            </div>
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-cream">
              How we build <span className="italic text-gold">together.</span>
            </h2>
          </Reveal>
        </div>

        <div className="divide-y divide-cream/10 border-t border-cream/10">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.04}>
              <div className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-10 md:py-12 items-start hover:pl-2 transition-all duration-500 cursor-hover">
                <span className="md:col-span-2 font-heading text-3xl md:text-4xl text-gold">{s.n}</span>
                <h3 className="md:col-span-4 font-heading text-2xl md:text-3xl text-cream group-hover:text-gold transition-colors duration-300">
                  {s.title}
                </h3>
                <p className="md:col-span-6 text-base text-cream/60 leading-relaxed">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
